export default __webpack_public_path__ + "static/media/cardano.7a8de13d.svg";